import type { ReferrerState } from 'src/hooks/use-referrer';
import {
  getTransportTab,
  transportTabPathname,
  type TransportTabPath,
} from 'src/pages/company-transactions/transport/tabs';
import { useCompanyTransactionsAccess } from 'src/pages/company-transactions/use-company-transactions-access';

/**
 * The back link of a page opened from the transactions list, for when the page
 * has no referrer (opened in a new browser tab, from an email or a
 * notification):
 * - with Company Transactions → the given tab,
 *   e.g. `useTransactionsFallback('surrender')` → "Back to Surrender"
 * - without Company Transactions → "Back to My Transactions"
 */
export function useTransactionsFallback(tab: TransportTabPath): ReferrerState {
  // TODO CARMA-1838: drop the access check together with the feature flag.
  const access = useCompanyTransactionsAccess();

  if (!access.loaded || !access.canAccess)
    return { label: 'My Transactions', location: '/reporting/my-transactions' };

  return {
    label: getTransportTab(tab).label,
    location: transportTabPathname(tab),
  };
}
